import {ExpirableApolloServiceProvider} from '@coolcolduk/ui-apollo-client';
import {MessageProvider} from '@coolcolduk/ui-mui';
import {CssBaseline, ThemeProvider} from '@mui/material';
import {firebaseAuth, getFirebaseFunction} from '../setup/firebase';
import AppRouter from './AppRouter';
import muiTheme from './orangeTheme';

/**
 * all provider stuff
 * @returns
 */
export default function App() {
  return (
    <ExpirableApolloServiceProvider
      url={getFirebaseFunction('csGql')}
      tokenFetcher={async () => firebaseAuth.currentUser?.getIdToken()}
    >
      <MessageProvider defaults={{durationMs: 5000}}>
        <ThemeProvider theme={muiTheme}>
          <CssBaseline />
          <AppRouter />
        </ThemeProvider>
      </MessageProvider>
    </ExpirableApolloServiceProvider>
  );
}
